'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_PurchaseOrderReference(number, issueDate) {
  this.z3 = null;
  this.z2 = null;
  this.z3 = number;
  this.z2 = issueDate;
}
export { $c_Lapp_data_PurchaseOrderReference as $c_Lapp_data_PurchaseOrderReference };
$p = $c_Lapp_data_PurchaseOrderReference.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_PurchaseOrderReference;
/** @constructor */
function $h_Lapp_data_PurchaseOrderReference() {
}
export { $h_Lapp_data_PurchaseOrderReference as $h_Lapp_data_PurchaseOrderReference };
$h_Lapp_data_PurchaseOrderReference.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_PurchaseOrderReference)) {
    if ((this.z3 === x$0.z3)) {
      var x = this.z2;
      var x$2 = x$0.z2;
      return ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "PurchaseOrderReference";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.z3;
  }
  if ((n === 1)) {
    return this.z2;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "number";
  }
  if ((n === 1)) {
    return "issueDate";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_data_PurchaseOrderReference(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jT)));
}
export { $isArrayOf_Lapp_data_PurchaseOrderReference as $isArrayOf_Lapp_data_PurchaseOrderReference };
var $d_Lapp_data_PurchaseOrderReference = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_PurchaseOrderReference, "app.data.PurchaseOrderReference", ({
  jT: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_PurchaseOrderReference as $d_Lapp_data_PurchaseOrderReference };
//# sourceMappingURL=app.data.-Purchase-Order-Reference.js.map
